import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "userSlice",
  initialState: {
    mainUserData: {},
    userData: {},
    showHealthForm: false,
    showTermOfUsePage: false,
    isHaveCreditCard: false,
    userToken: "",
  },
  reducers: {
    updateMainUserData: (state, action) => {
      state.mainUserData = action.payload;
    },
    updateUserData: (state, action) => {
      state.userData = action.payload;
    },
    updateDisplayingHealthForm: (state, action) => {
      state.showHealthForm = action.payload;
    },
    updateDisplayingTermOfUsePage: (state, action) => {
      state.showTermOfUsePage = action.payload;
    },
    updateUserToken: (state, action) => {
      state.userToken = action.payload;
    },
    updateIsHaveCreditCard: (state, action) => {
      state.isHaveCreditCard = action.payload;
    },
  },
});

export const {
  updateUserData,
  updateMainUserData,
  updateDisplayingHealthForm,
  updateDisplayingTermOfUsePage,
  updateUserToken,
  updateIsHaveCreditCard,
} = slice.actions;

export default slice.reducer;
